export const ALL_ARRAY = ['*'];
export const DEFAULT_GET_TABLES_INPUT = [];
